var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElement6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 101,
    viewBox: "0 0 88 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7511 89H0V100.725H23.7511V89Z",
    fill: "#FF7C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2722 15.2251L75.5496 0L87.5582 11.9675L72.2809 27.1926L87.5485 42.408L75.5398 54.3755L60.2722 39.1602L45.0184 54.3618L33.0098 42.3943L48.2637 27.1926L33 11.9812L45.0087 0.0136719L60.2722 15.2251Z",
    fill: "#FF7C3D"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    values: "0;1;0",
    repeatCount: "indefinite",
    begin: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement6);
export default __webpack_public_path__ + "static/media/element6.400cb83957698ea3d87826f91d2dff3d.svg";
export { ForwardRef as ReactComponent };